var React = require('react');

function AsanaChair (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M22,37h-6l2.281-6.533\n\tC14.075,28.437,11,28.458,11,25.188c0-3.195,3.334-3.684,7.397-10.291C20.669,11.201,21,4.204,21,2c0-1,0-2,0-2 M22.38,13.438\n\tl1.418-4.06c0,0-3.034-1.404-4.538-2.101c-1.503-0.696-3.287-0.041-3.982,1.462c-0.696,1.503-0.042,3.287,1.462,3.983\n\tc1.504,0.696,2.723,1.26,2.723,1.26S21,15.563,21,18.5c0,1.967-0.875,3.65-3.249,6.025c4.249,2.225,5.274,3.037,5.274,4.645\n\tc0,1.43-0.752,2.36-3.656,7.83"}));
}

AsanaChair.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaChair;

AsanaChair.default = AsanaChair;
